/* Light / dark theme toggle.
 * State lives in localStorage under "hihi-theme" ("dark" | "light").
 * The anti-flash inline script in layout/theme.liquid applies the stored
 * value to <html data-theme> before first paint; this script handles the
 * click interaction and keeps every [data-hihi-theme-toggle] button in sync.
 */
(function () {
  var KEY = 'hihi-theme';

  function current() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function apply(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    syncButtons(theme);
  }

  function syncButtons(theme) {
    var buttons = document.querySelectorAll('[data-hihi-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    }
  }

  function persist(theme) {
    try {
      localStorage.setItem(KEY, theme);
    } catch (e) {
      /* storage may be unavailable (private mode) — fall back to session-only */
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-hihi-theme-toggle]');
    if (!btn) return;
    var next = current() === 'dark' ? 'light' : 'dark';
    apply(next);
    persist(next);
  });

  // Reflect the initial state onto the buttons (aria-pressed).
  syncButtons(current());
})();
